
/* injects from baggage-loader */

import { BETSLIP_TYPE_EXPRESS } from "../../sport/betslip";

export const getPredefinedMultiples = (selectionIds, gameIds) => {
    const req =  {
        source: "betting",
        what: {
            sport: ['id', 'alias'],
            region: ['id', 'name', 'alias'],
            competition: ['id', 'name'],
            game: [],
            market: [],
            event: ["id", "order", "name", "price", "type", "base"]
        },
        where: { game: { id: { "@in": gameIds } }, event: { id: { "@in": selectionIds } } }
    }

    return req;
};

export const createPredefinedBet = (stake, multipleId, selections) => {
    const req = {
        name: "CreateBets",
        params: {
            Bets: [{
                InputMethod:1,
                AcceptTypeId: 0,
                TypeId: BETSLIP_TYPE_EXPRESS,
                Amount: +stake,
                StateId: 0,
                SelectionList: selections,
                PredefinedMultipleId: multipleId,
            }],
        }
    };

    return req;
};